import { render, staticRenderFns } from "./StudentViewHeader.vue?vue&type=template&id=66704e0c&"
import script from "./StudentViewHeader.vue?vue&type=script&lang=js&"
export * from "./StudentViewHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports